import httpService from '../Api/http.service';
import { getApiBaseUrl } from 'utils';

const getAppCoreBaseUrl = () => `${getApiBaseUrl()}/appcore`;

const createConsentRequest = (payload) =>
  httpService({
    url: getAppCoreBaseUrl() + '/consents',
    method: 'post',
    data: payload,
  });

const getConsentRequest = (consentId) =>
  httpService({
    url: getAppCoreBaseUrl() + `/consents/${consentId}`,
    method: 'get',
  });

const cancelConsentRequest = (consentId) =>
  httpService({
    url: getAppCoreBaseUrl() + `/consents/${consentId}`,
    method: 'delete',
  });

const resendConsentRequest = (consentId) =>
  httpService({
    url: getAppCoreBaseUrl() + `/consents/${consentId}/resend`,
    method: 'post',
  });

const getConsentsBySubscription = (subscriptionId) =>
  httpService({
    url: getAppCoreBaseUrl() + `/consents?subscription_id=${subscriptionId}`,
    method: 'get',
  });

const consentService = {
  createConsentRequest,
  getConsentRequest,
  cancelConsentRequest,
  resendConsentRequest,
  getConsentsBySubscription,
};

export default consentService;
